import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { AltraParte } from 'src/app/common/models/altraparte';
import { CreazionePraticaStoreService } from '../../../../services/creazione-pratica-store.service';
import { Parte } from 'src/app/common/models/parte';
import { OperationsService } from 'src/app/core/services/operations.service';
import { ServicePathsSettings } from 'src/app/core/configuration/service-paths-settings';
import { PropertiesSettings } from 'src/app/core/configuration/properties-settings';
import { Observable, Subject } from 'rxjs';
import { isParteAssociable } from '../../../../utils/parti-utils';
import { isAltraparteAssociated } from '../../../../utils/altraparte-utils';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-step-soggetti-terzi-list',
  templateUrl: './step-soggetti-terzi-list.component.html',
  styleUrls: ['./step-soggetti-terzi-list.component.css']
})
export class StepSoggettiTerziListComponent implements OnInit,OnChanges,OnDestroy {

  readonly PROPERTIES_SETTINGS = PropertiesSettings;

  @Input() associable:boolean;
  @Input() labelComponent:string;
  @Input() action:string;
  @Input() soggetti: { isAssociable: boolean, isAssociated: boolean, hasDetailsAnagrafica: boolean, option: AltraParte, categoria?: string, tipoSoggetto?: string }[] = [];
  @Output() actionEmitter: EventEmitter<string> = new EventEmitter<string>();

  activeIndex:number;
  associationParte: boolean;
  editingParte: boolean;
  parteSelected : AltraParte;

  altreParti: AltraParte[] = [];

  currentTab: String = "ANAGRAFICA";

  componentDestroyed$: Subject<void> = new Subject<void>();

  constructor(private operations: OperationsService,private creazionePraticaStoreService: CreazionePraticaStoreService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if(this.action !== this.labelComponent){
      this.associationParte = false;
      this.activeIndex = undefined;
      this.parteSelected = undefined;
    }
  }

  ngOnInit() {
    this.creazionePraticaStoreService.soggettoTerzo$.pipe(takeUntil(this.componentDestroyed$)).subscribe(altreParti => {
      if(altreParti){
        this.altreParti = altreParti;
        this.soggetti.forEach(element => {
          isAltraparteAssociated(element , this.altreParti)
        });
      }
    })
  }

  ngOnDestroy(): void {
    this.componentDestroyed$.next();
  }

  openDetail(option: {isAssociable:boolean,isAssociated:boolean, hasDetailsAnagrafica: boolean, option: AltraParte }, indice: number) {
    this.actionEmitter.emit(this.labelComponent);
    if(this.activeIndex === undefined || this.activeIndex !== indice){
      this.activeIndex = indice;
      this.parteSelected = option.option;
      if(option.isAssociable){
        this.editingParte = false;
        this.parteSelected = undefined;
      } else {
        this.editingParte = true;
      }
      if (!option.hasDetailsAnagrafica && option.option.parte.id && !option.option.parte.id.startsWith('TEMP')) {
        this.getAnagrafica(option.option.parte).subscribe(response => this.refreshElementInArray(indice, response));
      }
    } else {
      this.editingParte = false;
      this.associationParte = false;
      this.activeIndex = undefined;
      this.parteSelected = undefined;
    }

  }

  associa(option: AltraParte, indice: number) {
    this.actionEmitter.emit(this.labelComponent);
    this.editingParte = false;
    if(this.activeIndex === undefined || this.activeIndex !== indice && option){
      this.activeIndex = indice;
      this.associationParte = true;
      this.parteSelected = option;
    } else {
      this.associationParte = false;
      this.activeIndex = undefined;
    }
  }

  retrieveParte(parte: Parte , option: {isAssociable:boolean,isAssociated:boolean, hasDetailsAnagrafica: boolean, option: AltraParte }){
    this.parteSelected = option.option;
    this.activeIndex = undefined;
    if(parte){
      option.option.parte = parte;
      let isAssociable = isParteAssociable(parte);
      option.isAssociable = isAssociable;
      this.parteSelected = undefined;
      this.editingParte = false;
    }
  }

  retrieveAltraParte(altraparte: AltraParte){
    this.altreParti.push(altraparte);
    this.creazionePraticaStoreService.setSoggettiTerzi(this.altreParti);
    this.creazionePraticaStoreService.save();
    this.parteSelected = undefined;
    this.activeIndex = undefined;
    this.editingParte = false;
    this.associationParte = false;
  }

  setTab(type: string){
    this.currentTab = type;
  }

  private getAnagrafica(option: Parte): Observable<Parte> {
    return this.operations.getAnagrafica( ServicePathsSettings.URL_GET_PARTE , option.id, true);
  }

  private refreshElementInArray(indice: number, element: Parte):{isAssociable:boolean,isAssociated:boolean, hasDetailsAnagrafica: boolean, option: AltraParte } {
    this.soggetti[indice].isAssociable = isParteAssociable(element);
    this.soggetti[indice].hasDetailsAnagrafica = true;
    this.soggetti[indice].option.parte = element;
    return this.soggetti[indice];
  }

  modificaDati(option: any){
    this.parteSelected = option;
    this.editingParte = true;
  }

}
